import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeTh from '@angular/common/locales/th';
import { FileDropModule } from "ngx-file-drop";

registerLocaleData(localeTh, 'th');

// Routing Module
import { AppRoutes } from './app.routing';
import { AgGridModule } from 'ag-grid-angular';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuModule } from 'ngx-contextmenu';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { Select2Module } from 'ng2-select2';
// import { DataTablesModule } from 'angular-datatables';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { ToastrModule } from 'ngx-toastr';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { CustomFormsModule } from 'ng2-validation';
import { ToastyModule } from 'ng2-toasty';


// Layout
import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { CommonLayoutComponent } from './common/common-layout.component';
import { LoginComponent } from './common/login';
import { JwtInterceptor } from './_helpers';

import { LandUsedComponent } from './property/land-used/land-used.component';
import { NgSelectModule } from '@ng-select/ng-select';

/* Angular material */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CellRendererComponent } from './shared/cell-renderer/cell-renderer.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AdhocComponent } from './adhoc/adhoc.component';
import { PrintDeptorComponent } from './adhoc/print-deptor/print-deptor.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AddToSentPDSComponent } from './component/add-to-sent-pds/add-to-sent-pds.component';
import { PhotoUploadComponent } from './component/photo-upload/photo-upload.component';
import { RolesService } from './_services/roles.service';
import { MergeCondoComponent } from './adhoc/merge-condo/merge-condo.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { ConfigService } from './_services/config.service';
import { NoCacheHeadersInterceptor } from './NoCacheHeadersInterceptor';
import { MapCaptureComponent } from './property/map-capture/map-capture.component';
import { Pa2Component } from './tax-assesment/component/pa2/pa2.component';


export const configFactory = (configService: ConfigService) => {
  return () => configService.loadConfig();
};

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    CommonLayoutComponent,
    LoginComponent,
    CellRendererComponent,
    LandUsedComponent,
    CellRendererComponent,
    AdhocComponent,
    PrintDeptorComponent,
    AddToSentPDSComponent,
    PhotoUploadComponent,
    MergeCondoComponent,
    NotfoundComponent,
    MapCaptureComponent,
    Pa2Component
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(AppRoutes, { useHash: false }),
    HttpClientModule,
    NgbModule.forRoot(),
    ToastyModule.forRoot(),
    ContextMenuModule.forRoot(),
    AngularDateTimePickerModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormsModule,
    Select2Module,
    // DataTablesModule,
    NgxSpinnerModule,
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot(),
    AgGridModule,
    ScrollToModule.forRoot(),
    BrowserAnimationsModule,
    NgSelectModule,
    AccordionModule.forRoot(),
    FileDropModule,
  ],
  exports: [
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: NoCacheHeadersInterceptor,
    //   multi: true
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [ConfigService],
      multi: true
    },
    RolesService
  ],
  entryComponents: [CellRendererComponent, LandUsedComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }